<template>
    <input :placeholder="placeholder" type="text" v-on:input="checkValue" v-bind:class="invalid ? [addclass, 'invalid-input'] : addclass" class="form-input" v-bind="{id: idname}">
</template>


<script>
import IMask from 'imask';
export default {
    name: 'imasked-input',
	props: ["value", "idname", "invalid", "addclass", "mask", "placeholder"],
	methods: {
		checkValue: function (evt) {
			this.$emit('input', evt.target.value)
			this.$emit('change', evt)
		}
	},
	mounted() {
		let element = document.getElementById(this.idname);
		element.value = this.value.toUpperCase()
		if (this.addclass) {
			element.className += " " + this.addclass
		}
		let elemMask = this.mask
		if (element) {
			let patternMask = IMask(element, {
				mask: elemMask,
				lazy: true,  // make placeholder always visible
			});
            function onFocus() {
                setTimeout(function(){ 
                    let maskChars = '_/()\-+ '
                    let regex = new RegExp("["+maskChars+"]", 'g');
                    let val_str = element.value.replaceAll(regex, "")
                    val_str = val_str.replaceAll("-", "")
                    let val_str_length = val_str.length
                    //Replacing / correctly
                    let searchStart = 0
                    let iCount = 0
                    let ic = 0
                    while (searchStart < elemMask.length) {
                        ic += 1
                        iCount += 1
                        let symb_loc = elemMask.length
                        for (var i = 0; i < maskChars.length; i++) {
                            let curLoc = elemMask.indexOf(maskChars.charAt(i), searchStart)
                            if (curLoc == -1) {
                                continue
                            }
                            if (curLoc < symb_loc) {
                                symb_loc = curLoc
                            }

                        }
                        // let symb_loc = elemMask.indexOf("/", searchStart)
                        if (symb_loc == -1) {
                            break
                        }
                        if (symb_loc < val_str_length) {
                            val_str_length += 1
                        }
                        searchStart = symb_loc + 1
                        if (ic > 10) {
                            break
                        }
                    }
                    if (elemMask.indexOf("7") >= 0) {
                        val_str_length += 1
                    }
                    element.value = element.value.toUpperCase()
                    element.selectionStart = element.selectionEnd = val_str_length; 
                }, 0);
				patternMask.updateOptions({ lazy: false, mask: elemMask }); 
                
            }
			element.addEventListener('focus', function() {
                onFocus()
			  }, true);
			element.addEventListener('focusout', function() {
				let val = element.value.replace(/_/g, "").replace(/\//g, "").replace(/\(/g, "").replace(/\)/g, "").replace(/-/g, "").replace("+7", "")
				if (val == "") {
					patternMask.updateOptions({ lazy: true, mask:"" });
				}
				
			}, true);
            element.addEventListener('input', function() {
                onFocus()
			}, true);
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/ImaskInput.vue